import styled from 'styled-components';

const Root = styled.div `
  &.tend-ui-drawer-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: ${props => props.$justifyContent};
    padding: 16px 24px;
    border-top: none;
  }
`;

export { Root };
